<ng-container>
  <div class="field-container">
    <label class="form-label">{{ labelText }}<span class="text-danger" *ngIf="required">*</span></label>
    <p-inputgroup [ngClass]="recovery ? 'recover-data' : ''">
      <input id="input-group" [value]="inputValue" pInputText pSize="small" appendTo="body" [attr.data-key]="dataKey"
        disabled />
      @if (showClearButton) {
      <p-inputgroup-addon>
        <p-button icon="pi pi-times" severity="secondary" [pTooltip]="'Limpiar'" (onClick)="onClear()">
        </p-button>
      </p-inputgroup-addon>
      }
      <p-inputgroup-addon>
        <p-button [pTooltip]="titleButton" [icon]="iconButton" [disabled]="disabled" severity="secondary"
          (onClick)="handleClick($event)">
        </p-button>
      </p-inputgroup-addon>
    </p-inputgroup>
  </div>
</ng-container>